// src/components/section-templates/VideoGridSection.jsx
import React from "react";
import VideoCard from "../VideoCard";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";
import "./VideoGridSection.css";

export default function VideoGridSection({
  title,
  description,
  videos = [],
  // optional overrides for this grid's animation timing:
  delayChildren = 0,
  staggerChildren = 0.09,
}) {
  return (
    <section className="container video-grid-section">
      {title && <h2 className="container ">{title}</h2>}
      {description && (
        <p className="container vgs-description">{description}</p>
      )}

      <MotionContainer
        className="video-grid"
        delayChildren={delayChildren}
        staggerChildren={staggerChildren}
      >
        {videos.map((video, i) => (
          <MotionItem key={i} className="video-grid-item">
            <VideoCard
              title={video.title}
              src={video.src}
              description={video.description}
              tags={video.tags}
              thumbnail={video.thumbnail}
            />
          </MotionItem>
        ))}
      </MotionContainer>
    </section>
  );
}
